// extracted by mini-css-extract-plugin
module.exports = {"splotch":"colorTag_splotch__m6Xua","spanWrapper":"colorTag_spanWrapper__UOVsc"};